<div
  style="width: 100%"
  [ngClass]="cls"
  style="position: relative; top: 0; left: 0"
>
  <mat-form-field style="width: 100%" floatLabel="always">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      [required]="_required"
      [readonly]="readonly"
    />

    <mat-autocomplete
      autoActiveFirstOption
      #auto="matAutocomplete"
      [displayWith]="displayWith"
    >
      <cdk-virtual-scroll-viewport
        [ngStyle]="{ height: '256px' }"
        [minBufferPx]="1000"
        [maxBufferPx]="1000"
        [itemSize]="itemSize"
      >
        <mat-option
          *cdkVirtualFor="let option of filteredOptions | async"
          [value]="option"
          [ngClass]="optionCls"
        >
        <div class="user-autocomplete-option-content">
          <span style="font-weight: 600" *ngIf="option.fname || option.lname">
            {{ option.fname }} {{ option.lname }}
          </span>
          <span
            style="font-weight: 600"
            *ngIf="!(option.fname || option.lname) && (option.first_name || option.last_name)"
          >
            {{ option.first_name }} {{ option.last_name }}
          </span>
          <span *ngIf="option.blocked" class="user-autocomplete-error-option-2">
            Gesperrt
          </span>
          <span *ngIf="option.deleted" class="user-autocomplete-error-option-2">
            Gelöscht
          </span>
          <br />
          <ng-container *ngIf="_address">
            {{ option.address }} <br />
            {{ option.zip }} {{ option.city }}<br />
          </ng-container>
          ID: {{ option.id }}

        </div>
        </mat-option>
      </cdk-virtual-scroll-viewport>
    </mat-autocomplete>
  </mat-form-field>
  <div class="user-autocomplete-error"
  style="width:min-content;"
  *ngIf="_value?.blocked">Gesperrt</div>
  <div class="user-autocomplete-error" *ngIf="_value?.deleted">Gelöscht</div>
</div>
